import React from "react";
import { ChevronRight } from "lucide-react";

export default function ErpPageHeader({
  title,
  description,
  breadcrumbs = [],
  actions,
  className = "",
}) {
  return (
    <header className={`mb-5 space-y-3 ${className}`}>
      {breadcrumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1 text-xs text-slate-500">
          {breadcrumbs.map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
              {index > 0 && <ChevronRight className="h-3 w-3" />}
              <span className={index === breadcrumbs.length - 1 ? "font-medium text-slate-700" : ""}>
                {item}
              </span>
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
            {title}
          </h1>
          {description && (
            <p className="mt-1 max-w-3xl text-sm text-slate-500">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
        )}
      </div>
    </header>
  );
}
